module.exports = __webpack_public_path__ + "static/media/plan-payment.241917cd.svg";